export type HangupReason = 'dtls_timeout' | 'dtls_error' | 'ice_failed' | 'other';

// Janus's verbatim strings (janus_ice_webrtc_hangup callers in ice.c / dtls.c).
const REASON_BY_RAW: Record<string, HangupReason> = {
  'DTLS timeout': 'dtls_timeout',
  'DTLS error': 'dtls_error',
  'ICE failed': 'ice_failed',
};

export const classifyHangupReason = (reason: string | undefined): HangupReason =>
  (reason && REASON_BY_RAW[reason]) || 'other';

export const isRecoverableHangupReason = (reason: HangupReason) => reason !== 'other';
